module.exports = __webpack_public_path__ + "static/img/thank-you.967a973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thank-you.png
// module id = 191p
// module chunks = 36